import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import Footer from '../../components/Footer';
import { 
  Key, 
  Calendar, 
  Shield, 
  Users, 
  CreditCard,
  Clock,
  ArrowRight,
  CheckCircle
} from 'lucide-react';

export default function VehicleRentalsPage() {
  return (
    <div className="min-h-screen bg-[#F5F7FA]">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-xl border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2">
              <img 
                src="https://customer-assets.emergentagent.com/job_mercamove/artifacts/ch8knfdf_Move_Logo_wHT.png" 
                alt="Mercapoli Move"
                className="h-8"
              />
            </Link>
            <div className="flex items-center gap-4">
              <Link to="/login">
                <Button variant="ghost" className="text-slate-700 hover:text-[#00BFA6]">
                  Iniciar Sesión
                </Button>
              </Link>
              <Link to="/register">
                <Button className="btn-primary px-6 py-2 text-sm">
                  Registrarse
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="pt-32 pb-16 px-4 bg-gradient-to-br from-[#FFD166]/5 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#FFD166]/10 rounded-full mb-6">
                <Key className="w-5 h-5 text-[#FFD166]" />
                <span className="text-[#FFD166] font-medium text-sm">Renta de Vehículos</span>
              </div>
              <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 font-['Outfit'] leading-tight">
                Renta de Vehículos
                <span className="text-[#FFD166]"> Flexible y Segura</span>
              </h1>
              <p className="text-lg text-slate-600 mt-6 leading-relaxed">
                Con Mercapoli Move puedes rentar vehículos por horas, días o semanas 
                directamente de propietarios verificados.
              </p>
              <p className="text-slate-600 mt-4">
                Ideal para viajes personales, trabajo, turismo o logística. Sin intermediarios 
                innecesarios y con precios transparentes.
              </p>
              <Link to="/register">
                <Button className="btn-primary mt-8 h-14 px-8 text-lg">
                  Explorar vehículos disponibles
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
              </Link>
            </div>
            <div className="relative">
              <img 
                src="https://images.unsplash.com/photo-1485291571150-772bcfc10da5?w=600&h=400&fit=crop" 
                alt="Vehicle Rentals"
                className="rounded-3xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold text-slate-900 font-['Outfit'] text-center mb-12">
            Características Principales
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-slate-50 p-6 rounded-2xl">
              <div className="w-14 h-14 bg-[#00BFA6]/10 rounded-xl flex items-center justify-center mb-4">
                <Users className="w-7 h-7 text-[#00BFA6]" />
              </div>
              <h3 className="text-xl font-bold text-slate-800 mb-2">Car Sharing</h3>
              <p className="text-slate-600">Accede a vehículos de propietarios particulares verificados en tu zona.</p>
            </div>
            <div className="bg-slate-50 p-6 rounded-2xl">
              <div className="w-14 h-14 bg-[#FFD166]/10 rounded-xl flex items-center justify-center mb-4">
                <Clock className="w-7 h-7 text-[#FFD166]" />
              </div>
              <h3 className="text-xl font-bold text-slate-800 mb-2">Renta por tiempo flexible</h3>
              <p className="text-slate-600">Elige entre renta por horas, días o semanas según tus necesidades.</p>
            </div>
            <div className="bg-slate-50 p-6 rounded-2xl">
              <div className="w-14 h-14 bg-[#00BFA6]/10 rounded-xl flex items-center justify-center mb-4">
                <Shield className="w-7 h-7 text-[#00BFA6]" />
              </div>
              <h3 className="text-xl font-bold text-slate-800 mb-2">Seguro integrado</h3>
              <p className="text-slate-600">Todas las rentas incluyen seguro de cobertura para tu tranquilidad.</p>
            </div>
            <div className="bg-slate-50 p-6 rounded-2xl">
              <div className="w-14 h-14 bg-[#FFD166]/10 rounded-xl flex items-center justify-center mb-4">
                <CheckCircle className="w-7 h-7 text-[#FFD166]" />
              </div>
              <h3 className="text-xl font-bold text-slate-800 mb-2">Verificación de usuarios</h3>
              <p className="text-slate-600">Tanto propietarios como arrendatarios son verificados para mayor seguridad.</p>
            </div>
            <div className="bg-slate-50 p-6 rounded-2xl">
              <div className="w-14 h-14 bg-[#00BFA6]/10 rounded-xl flex items-center justify-center mb-4">
                <CreditCard className="w-7 h-7 text-[#00BFA6]" />
              </div>
              <h3 className="text-xl font-bold text-slate-800 mb-2">Pagos digitales</h3>
              <p className="text-slate-600">Paga de forma segura con Digi Wallet, tarjeta o tokens DIGGII.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 bg-[#FFD166]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-slate-900 font-['Outfit'] mb-4">
            Encuentra el vehículo perfecto
          </h2>
          <p className="text-slate-800 text-lg mb-8">
            Miles de vehículos disponibles cerca de ti.
          </p>
          <Link to="/register">
            <Button className="bg-slate-900 text-white hover:bg-slate-800 h-14 px-8 text-lg rounded-full">
              Ver Vehículos
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
